
import { useStore } from 'react-admin';
import { MapAttributeType } from '../models/map-attribute';
import { filterDefaultMapAttribute } from '../components/global-map-filter/global-map-filter';

export const useMapAttributeType = (): [MapAttributeType] => {
  const [mapAttributeType] = useStore<MapAttributeType>('map.mapAttribute.id', filterDefaultMapAttribute);
  return [mapAttributeType];
}

export const useMapAttributeName = (): [string] => {
  const [mapAttributeName] = useStore<string>('map.mapAttribute.name', '');
  return [mapAttributeName];
}
